import { useMemo, useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { useData } from "@/context/DataContext";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const tokens = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(/[^a-z0-9]+/).filter((t) => t.length > 1);
const score = (a, b) => {
  const tb = tokens(b);
  return tokens(a).reduce((s, t) => s + (tb.includes(t) ? 3 : tb.some((x) => x.startsWith(t.slice(0, 4)) || t.startsWith(x.slice(0, 4))) ? 1 : 0), 0);
};

export const QuickLinkSelect = ({ name, excludeId, onPick, busy, testId }) => {
  const { employees } = useData();
  const [open, setOpen] = useState(false);
  const ranked = useMemo(() => employees.filter((e) => e.active !== false && e.id !== excludeId)
    .map((e) => ({ ...e, s: score(name, e.name) })).sort((a, b) => b.s - a.s || a.name.localeCompare(b.name)), [employees, name, excludeId]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" variant="outline" disabled={busy} className="h-8 w-full justify-between sm:w-56" data-testid={testId}>
          <span className="truncate">{busy ? "Collegamento…" : "Collega a dipendente"}</span><ChevronsUpDown className="ml-1 h-3.5 w-3.5 opacity-60" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-0" align="end">
        <Command>
          <CommandInput placeholder="Cerca dipendente…" data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>Nessun dipendente trovato</CommandEmpty>
            {[["Suggeriti", ranked.filter((e) => e.s > 0)], ["Tutti i dipendenti in forza", ranked.filter((e) => e.s === 0)]].map(([h, list]) => list.length > 0 && (
            <CommandGroup key={h} heading={h}>
              {list.map((e) => (
                <CommandItem key={e.id} value={`${e.name} ${e.id}`} onSelect={() => { setOpen(false); onPick(e); }} data-testid={`${testId}-opt-${e.id}`}>
                  {e.s > 0 && <Check className="mr-2 h-3.5 w-3.5 text-emerald-600" />}{e.name}
                </CommandItem>
              ))}
            </CommandGroup>))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
